import { requiredMessage } from "@/components/forms/requiredMessage.tsx";
import { validatePort as validatePortRange } from "@/modules/network/validatePort.ts";
import { i18n } from "@lingui/core";
import { t } from "@lingui/core/macro";

export function validatePort(value: number | undefined | null) {
    if (!value) return i18n._(requiredMessage);
    return validatePortRange(value);
}

// TODO: should we use this somewhere?
function _validateStartPort(value: number | undefined, rules: { port_start: number }[], rulesContainSelf: boolean) {
    const portResult = validatePort(value);
    if (portResult !== undefined) {
        return portResult;
    }

    const found = rules.filter((item) => item.port_start === value);
    return (rulesContainSelf ? found.length > 1 : found.length > 0) ? t`Start port must be unique` : undefined;
}

export function validateEndPort(port_end: number | undefined | null, port_start: number | undefined | null) {
    if (port_end == null || Number.isNaN(port_end)) {
        return undefined;
    }

    const portResult = validatePort(port_end);
    if (portResult !== undefined) {
        return portResult;
    }

    if (port_start != null && port_end < port_start) {
        return t`End port must be greater than start port`;
    }
    return undefined;
}
